import { FC } from "react";

import Box, { BoxProps } from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Heading from "sections/nfcTagsPage/Heading";

import ImageNext from "components/ImageNext";

interface BridgeSectionProps {
  boxProps?: BoxProps;
}

const BridgeSection: FC<BridgeSectionProps> = ({ boxProps }) => {
  return (
    <Box component="section" display="grid" {...boxProps}>
      <Heading heading="Bridge to the digital world" />

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 3,
          justifyContent: "space-around",
        }}
      >
        <Typography paragraph sx={{ maxWidth: 600 }}>
          Your digital assets are permanently and directly linked to physical
          objects. NFC technology allows users to scan their items at any time.
          <br />
          <br />
          In addition to key product information, your can display any data to
          the users on a customized landing page.
          <br />
          <br />
          Our labels are fully customizable to match your brand perfectly.
          <br />
          <br />
          Tags can be attached to anything - either directly sewed to the
          clothes or added to the hanging labels.
        </Typography>

        <ImageNext
          src={`${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/nfcTagsPage/bridge/image-new.png`}
          width={770}
          height={451}
          alt=""
          style={{
            width: "100%",
            maxWidth: 650,
            objectFit: "contain",
            height: "auto",
            margin: "0 auto",
          }}
        />
      </Box>
    </Box>
  );
};

export default BridgeSection;
